<template>
  <div class="mobile-box">
    <Router-view :key="key" />
    <van-tabbar
      class="tabbar-box"
      route
      fixed
      :border="false"
      z-index="999"
      active-color="#333"
      inactive-color="#666"
    >
      <van-tabbar-item replace to="/index">
        <span>首页</span>
        <template #icon="props">
          <img
            :src="
              props.active
                ? require('@/assets/img/mobile-img/home-tabbar-active.png')
                : require('@/assets/img/mobile-img/home-tabbar.png')
            "
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/scholar-service">
        <span>学者服务</span>
        <template #icon="props">
          <img
            :src="
              props.active
                ? require('@/assets/img/mobile-img/scholar-tabbar-active.png')
                : require('@/assets/img/mobile-img/scholar-tabbar.png')
            "
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/partner-service">
        <span>知识合伙人</span>
        <template #icon="props">
          <img
            :src="
              props.active
                ? require('@/assets/img/mobile-img/partne-tabbar-active.png')
                : require('@/assets/img/mobile-img/partne-tabbar.png')
            "
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/My">
        <span>我的</span>
        <template #icon="props">
          <img
            :src="
              props.active
                ? require('@/assets/img/mobile-img/my-tabbar-active.png')
                : require('@/assets/img/mobile-img/my-tabbar.png')
            "
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { Tabbar, TabbarItem } from "vant";
export default {
  components: {
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem,
  },
  computed: {
    // 唯一的一个Key用于搜索后页面二次刷新
    key() {
      return this.$route.name
        ? this.$route.name + +new Date()
        : this.$route + +new Date();
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.mobile-box {
  min-height: 100vh;
  padding-bottom: 55px;
  background-color: #f5f5f5;

  .tabbar-box {
    height: 55px;
  }
}
</style>